import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../shared/services/loader.service';
import { MonitorService } from '../shared/monitor.service';
import { HttpErrorResponse } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { ErrorHandlerService } from '../../shared/services/error-handler.service';

@Component({
  selector: 'app-monitor-http',
  templateUrl: './monitor-http.component.html',
  styleUrls: ['./monitor-http.component.scss', '../monitoring.component.scss']
})
export class MonitorHttpComponent implements OnInit {

  title = 'HTTP Traces';

  traces: any[];
  loadedTrace = false;

  constructor(
    private monitorService: MonitorService,
    private loader: LoaderService,
    private toastr: ToastrService,
    private errorHandler: ErrorHandlerService,
  ) {
    this.loadHttpTrace();
  }

  ngOnInit() {
  }

  loadHttpTrace() {
    this.loader.startLoad();
    this.monitorService.trace()
      .pipe(finalize(() => this.loader.stopLoad()))
      .subscribe(traces => {
        console.log(traces);
        this.traces = traces;

        this.loadedTrace = true;
      }, e => this.errorHandler.handleHttpError(e, 'monitoring.status.errors.load-http'));

  }

  showFullTrace(trace) {
    trace.showFullTrace = !trace.showFullTrace;
  }

  isTrace2xx(trace): boolean {
    const regex = /^(2[0-9]{2})$/ig;

    return trace.info.headers.response.status.match(regex);
  }

}
